<template>
    <div class="bread-crumbs">
        <div class="bread-crumb">
            <a class="no-link" href="//www.cdc.gov/">CDC</a>
            <span class="lt"></span>
            <a class="no-link" href="//www.cdc.gov/BRFSS">BRFSS</a>
            <span class="lt"></span>
            <brfss-router-link
                :item="indexItem"
                title="WEAT"
            ></brfss-router-link>
            <template v-for="(crumb, index) in breadCrumbLinks">
                <span class="lt" v-bind:key="toKey(crumb, index, 'lt')"></span>
                <brfss-router-link
                    v-bind:key="toKey(crumb, index, '')"
                    :item="crumb"
                ></brfss-router-link>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import brfssRouterLink from '@/components/sub/brfssRouterLink';
import navMenuItems from '@/scripts/nav/menuItems';

export default {
    props: [],
    computed: {
        ...mapState({
            breadCrumbLinks: (state) => state.display.breadCrumbLinks
        })
    },
    components: {
        'brfss-router-link': brfssRouterLink
    },
    created: function () {},
    data: function () {
        return {
            menuItems: navMenuItems.menuItems.byName,
            indexItem: navMenuItems.menuItems.byName.analysis
        };
    },
    methods: {
        toKey: function (crumb, index, suffix) {
            let formattedSufix = suffix ? '_' + suffix : '';
            return crumb.url + '_' + index + formattedSufix;
        }
    }
};
</script>

<style scoped>
.bread-crumbs {
    padding: 0 15px 0 15px;
    font-size: 0.875rem;
    font-family: 'Open Sans', apple-system, BlinkMacSystemFont, 'Segoe UI',
        'Helvetica Neue', Arial, sans-serif;
    font-weight: 400;
}

@media (max-width: 767px) {
    .bread-crumbs {
        display: none;
    }
}
.bread-crumbs .bread-crumb {
    min-height: 35.61px;
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 0;
    width: 100%;
    padding-left: 1px;
}

.bread-crumbs .bread-crumb span {
    /* width: 20px;  */
    margin: 0 -1px 0 -1px;
}

span a {
    color: #000;
    text-decoration: underline;
}

.bread-crumbs .bread-crumb span a:hover {
    text-decoration: none;
}

.bread-crumbs .bread-crumb span.gt:before {
    content: '\003c';
    margin: 0 5px;
}

.bread-crumbs .bread-crumb span.lt:before {
    content: '\003e';
    margin: 0 5px;
}

.bread-crumbs .bread-crumb div.prefix {
    display: none;
}
</style>
